import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./StaffClientsModal.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CstmPagination } from "components/Common/Common";
import { useGetStaffClientsListQuery } from "store/services/staff";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { MANAGE_STAFF, MANAGE_STAFF_TASK_LIST } from "config/paths";
import { CloseIcon } from "Assets/icons";

const StaffClientsModal = ({ staffId, taskType, show, setShow }) => {

    //   const { id: staffId, taskType } = useParams();
    const navigate = useNavigate()

    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState({ search: "", task_type: "single", sort: { column: "id", direction: "desc" } });

    const { data, isLoading, isError, isFetching } = useGetStaffClientsListQuery({ id: staffId, payload: { page: currentPage, limit: pageSize, ...filter } }, { skip: !staffId });
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const column = [
        {
            head: "Last Name",
            accessor: "LastName",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold">{item?.lastname || "--"}</h6>
            ),
        },
        {
            head: "First Name",
            accessor: "FirstName",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold">{item?.firstname || "--"}</h6>
            ),
        },
        {
            head: "Client Type",
            accessor: "client_type",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold text-capitalize">{item?.client_type || "--"}</h6>
            ),
        },
        {
            head: "Task Type",
            accessor: "FirstName",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold text-capitalize">{item?.task?.task_type == "single" ? "Individual" : (item?.task?.task_type || "--")}</h6>
            ),
        },
            {
                head: "Action",
                accessor: "action",
                isComponent: true,
                component: (item, ind) => (
                    <div className="ActnBtn d-flex align-items-center  gap-10">
                        <Button
                            type="button"
                            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
                            style={{ height: "30px", width: "60px", minWidth: "60px" }}
                        // onClick={(e) => { e.stopPropagation(); navigate(MANAGE_STAFF_TASK_LIST.replace(":taskType", taskType).replace(":staffId", staffId).replace("/:clientId", "")) }}
                        >
                            Select
                        </Button>
                    </div>
                ),
            }
    ];
    console.log('MANAGE_STAFF_TASK_LIST.replace(":taskType", taskType).replace(":staffId", staffId).replace("/:clientId", "")) ', MANAGE_STAFF_TASK_LIST.replace(":taskType", taskType).replace(":staffId", staffId).replace("/:clientId", ""))
    const resetFilter = () => {
        setFilter((prev) => ({ ...prev, search: "", sort: { column: "id", direction: "desc" } }));
        setCurrentPage(1)
    };

    const handleFilterChange = (key) => (value) => {
        setFilter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handlePopup = () => setShow(false)

    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist}  AssignChecklist`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable="true"
                size="lg"
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    <div onClick={handlePopup} style={{ display: "inline-block" }}>
                        <Button

                            className="cursor-pointer border-0 p-0 position-absolute"
                            variant="transparent"
                            style={{ right: 15, top: 10, cursor: "pointer", lineHeight: "0", verticalAlign: "middle" }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    {/* <div>
                        <h6 className="m-0 fw-bold themeBlue">Pre-Appointment Form Submitted by Guardian.</h6>
                    </div> */}
                    <section
                        className={`${styles.ClientDetail} position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row>
                                <Col
                                    lg="12"
                                    className=""
                                >
                                    <Row>
                                        <Col lg="12" className="my-3">
                                            {/* <div className="my-3">
                                                <ul className="list-unstyled mb-0 d-flex align-items-center">
                                                    <li className="m-0 p-0">
                                                        <Link
                                                            className="themeBlue fw-sbold"
                                                            style={{ textDecoration: "underline" }}
                                                            to={MANAGE_STAFF}
                                                        >
                                                            Manage Staff
                                                        </Link>
                                                    </li>
                                                    <li className="">
                                                        <h5 className="m-0 fw-bold themeBlue">
                                                            / Clients
                                                        </h5>
                                                    </li>
                                                </ul>
                                            </div> */}
                                            <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                                                <div className="left">
                                                    <TableHeader
                                                        heading={"Clients"}
                                                        handleFilterChange={handleFilterChange}
                                                        filter={filter}
                                                        resetFilter={resetFilter}
                                                        searchPlaceholder="Client Last, First Name"
                                                        // filterComponent={
                                                        //     <>
                                                        //         <li>
                                                        //             <Dropdown onSelect={(selected) => handleFilterChange("task_type")(selected)}>
                                                        //                 <Dropdown.Toggle
                                                        //                     className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                                                        //                     variant="transparent"
                                                        //                     id="dropdown-basic"
                                                        //                 >
                                                        //                     <div className="d-flex">
                                                        //                         <div>
                                                        //                             {filter?.task_type || "Task Type"}
                                                        //                         </div>
                                                        //                         <span className="icn" style={{ margin: "0 20px" }}>
                                                        //                             <svg
                                                        //                                 xmlns="http://www.w3.org/2000/svg"
                                                        //                                 width="12"
                                                        //                                 height="8"
                                                        //                                 viewBox="0 0 12 8"
                                                        //                                 fill="none"
                                                        //                             >
                                                        //                                 <path
                                                        //                                     d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                        //                                     fill="black"
                                                        //                                 />
                                                        //                             </svg>
                                                        //                         </span>
                                                        //                     </div>
                                                        //                 </Dropdown.Toggle>

                                                        //                 <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                                                        //                     <Dropdown.Item eventKey={"single"}>Individual</Dropdown.Item>
                                                        //                     <Dropdown.Item eventKey={"group"}>Group</Dropdown.Item>
                                                        //                 </Dropdown.Menu>
                                                        //             </Dropdown>
                                                        //         </li>
                                                        //     </>
                                                        // }
                                                    />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg="12" className="my-3">
                                            <div className="table-outer">
                                                {isFetching ? (
                                                    <div style={{ height: "200px" }}>
                                                        <LoadingIndicator />
                                                    </div>
                                                ) : isError ? (
                                                    <ErrorComponent />
                                                ) : (
                                                    <>
                                                        {(isFetching) && <LoadingOverlay />}
                                                        <TableLayout
                                                            height="calc(100vh - 320px)"
                                                            data={data?.records || []}
                                                            column={column}
                                                            url={MANAGE_STAFF_TASK_LIST.replace(":taskType", taskType).replace(":staffId", staffId).replace("/:clientId", "")}
                                                        />
                                                    </>
                                                )}
                                                <CstmPagination
                                                    totalPages={totalPages}
                                                    activePage={currentPage}
                                                    handlePageChange={handlePageChange}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Container>
                    </section>

                </Modal.Body>
            </Modal >
        </>
    );
};

export default StaffClientsModal;